import { Component, OnInit, AfterViewInit } from "@angular/core";
import { ProfileService } from "../../providers/profile.service";
import { SubscriptionService } from "../../providers/subscription.service";
import * as math from "mathjs/dist/math";
import { LoadingOverlayComponent } from "../../shared/loading-overlay/loading-overlay.component";
import { BvDialogTitleComponent, BvDialogBodyComponent, BvDialogFooterComponent } from "../../design-system/primitives/dialog.component";
import { CreditCardComponent } from "../credit-card/credit-card.component";
import { CloseDialogButtonComponent } from "../../shared/close-dialog-button/close-dialog-button.component";
import { CurrencyPipe } from "@angular/common";
import { BvButtonComponent } from "../../design-system/primitives/button.component";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: "app-pay-invoice",
    templateUrl: "./pay-invoice.component.html",
    styleUrls: ["./pay-invoice.component.scss"],
    imports: [LoadingOverlayComponent, BvDialogTitleComponent, BvDialogBodyComponent, CreditCardComponent, BvDialogFooterComponent, CloseDialogButtonComponent, BvButtonComponent, CurrencyPipe, TranslateModule]
})
export class PayInvoiceComponent implements OnInit {
  amount_due!: number;
  constructor(
    public profServ: ProfileService,
    private subServ: SubscriptionService
  ) {}

  ngOnInit() {
    if (!this.subServ.stripe) this.subServ.initStripe();
    this.amount_due = math.round(
      this.profServ.latestProfile.amount_due / 100,
      2
    );
  }
  ngAfterViewInit() {
    this.subServ.card.mount("#card-element");
  }
  payInvoice() {
    this.subServ.payInvoice();
  }
}
